import { useLocation } from 'react-router';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { ErrorState, PageLoader } from '@/components/ui/Feedback';
import { isPreviewRequested, SiteProvider, useSiteBundleQuery } from '@/features/site/SiteProvider';

/** Loads the site content bundle (contact details, copy, SEO) once, then renders the public site. */
export function PublicShell() {
  const { search } = useLocation();
  const bundle = useSiteBundleQuery(isPreviewRequested(search));

  if (bundle.isPending) return <PageLoader label="Loading website" />;
  if (bundle.isError) {
    return (
      <div className="container-page grid min-h-screen place-items-center py-16">
        <div className="w-full max-w-lg">
          <ErrorState error={bundle.error} onRetry={() => void bundle.refetch()} title="The website could not be loaded" />
        </div>
      </div>
    );
  }
  return (
    <SiteProvider bundle={bundle.data}>
      <PublicLayout />
    </SiteProvider>
  );
}
